import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button", "status"]
  static values = { copiedText: String, resetText: String }

  async copy() {
    const text = this.sourceTarget.value

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      this.sourceTarget.focus()
      this.sourceTarget.select()
      document.execCommand("copy")
    }

    this.buttonTarget.textContent = this.hasCopiedTextValue ? this.copiedTextValue : "Copied"
    this.statusTarget.textContent = this.hasCopiedTextValue ? "Webhook URL copied to your clipboard." : "Widget code copied to your clipboard."
    window.setTimeout(() => { this.buttonTarget.textContent = this.hasResetTextValue ? this.resetTextValue : "Copy widget code" }, 2_000)
  }
}
